import { FindPersonProfileProblem } from "@signalist/shared-types";

/**
 * The words for each problem a profile or a rule can have, under `defineIcps.bulkFindPeople`: one
 * key per problem, from a closed map, never the problem's name itself (apps/web §10).
 */
export const PROBLEM_KEY: Record<FindPersonProfileProblem, string> = {
	NO_POSITION: "problem.noPosition",
	NO_TITLE: "problem.noTitle",
	NO_PERSONA: "problem.noPersona",
	NO_DEPARTMENT_OR_SENIORITY: "problem.noDepartmentOrSeniority",
	NO_PLACE: "problem.noPlace",
};

/** What an override rule with each problem still needs, as the API words it too. */
export const RULE_PROBLEM_KEY: Record<FindPersonProfileProblem, string> = {
	NO_POSITION: "ruleProblem.noPosition",
	NO_TITLE: "ruleProblem.noTitle",
	NO_PERSONA: "ruleProblem.noPersona",
	NO_DEPARTMENT_OR_SENIORITY: "ruleProblem.noDepartmentOrSeniority",
	NO_PLACE: "ruleProblem.noPlace",
};
